import * as React from 'react';

import { InterestForm } from '@/components/engagement/interest-form';
import { contactPage } from '@/content/engagement';
import { TDC_CONTACT_EMAIL, TDC_CONTACT_MAILTO } from '@/lib/external-links';

export function ContactPage() {
  React.useEffect(() => {
    const previous = document.title;
    document.title = contactPage.documentTitle;
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <article className="px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
      <div className="mx-auto grid w-full max-w-7xl gap-10 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:items-start">
        <div>
          <p className="text-primary mb-3 text-xs font-medium tracking-[0.2em] uppercase">
            {contactPage.eyebrow}
          </p>
          <h1 className="font-display text-foreground max-w-2xl text-4xl font-semibold tracking-tight sm:text-5xl">
            {contactPage.title}
          </h1>
          <p className="text-muted-foreground mt-5 max-w-xl text-base leading-relaxed sm:text-lg">
            {contactPage.lead}
          </p>
          <p className="text-muted-foreground mt-4 text-sm">
            Direct:{' '}
            <a
              href={TDC_CONTACT_MAILTO}
              className="text-primary underline-offset-4 hover:underline"
            >
              {TDC_CONTACT_EMAIL}
            </a>
          </p>
        </div>
        <InterestForm
          idPrefix="contact"
          defaultInterest="general"
          heading="Contact form"
          description="We’ll open a prepared message to the Tour De Cure NextOnVera inbox."
        />
      </div>
    </article>
  );
}
